import { render, staticRenderFns } from "./IVR.vue?vue&type=template&id=793d7c08"
import script from "./IVR.vue?vue&type=script&lang=js"
export * from "./IVR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports